module.exports = __webpack_public_path__ + "media/assets/icons/carousel-fourth-07b911145cfd903d61a36eaded78cc1a.png";